export const lightTheme = {
  text: "#111517",
  input: "#858585",
  background: "#fafafa",
  elements: "#ffffff",
};

export const darkTheme = {
  text: "#ffffff",
  input: "#858585",
  background: "#202c37",
  elements: "#2b3945",
};
